module.exports = __webpack_public_path__ + "img/video.15273b4f.png";